"use strict";

function isFirefox() {
  return /firefox/i.test(navigator.userAgent);
}

module.exports = isFirefox;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/react-dnd/dist-modules/utils/isFirefox.js
 ** module id = 1070
 ** module chunks = 1
 **/